/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Title1Inputs */

const zh_accountsettings_title1 = /** @type {(inputs: Accountsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户设置`)
};

const en_accountsettings_title1 = /** @type {(inputs: Accountsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Settings`)
};

const es_accountsettings_title1 = /** @type {(inputs: Accountsettings_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de cuenta`)
};

/**
* | output |
* | --- |
* | "Account Settings" |
*
* @param {Accountsettings_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_title1 = /** @type {((inputs?: Accountsettings_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_title1(inputs)
	if (locale === "en") return en_accountsettings_title1(inputs)
	return es_accountsettings_title1(inputs)
});
export { accountsettings_title1 as "accountSettings_title" }